<rav-modal [modalId]="'shareDocuments'">
  <div class="grid-x align-top align-justify margin-bottom-1">
    <div class="cell auto">
      <h3>Share File</h3>
    </div>
  </div>

  <div *ngIf="selectedDocuments && selectedDocuments.length === 1">
    <div class="grid-x margin-bottom-1">
      <label class="cell small-4">Link Sharing {{ showShareableLink ? 'Active' : 'Inactive' }}</label>
      <mat-slide-toggle
        class="margin-left-1"
        (change)="setShareableLink()"
        [(checked)]="showShareableLink"
        data-cy="show-shareable-link"
      ></mat-slide-toggle>
    </div>
    <div>
      <div class="fade-in" [ngClass]="{ visible: showShareableLink }">
        <div class="input-group">
          <input class="input-group-field" value="{{ shareableLink }}" type="text" disabled name="shareable-link" />
          <div class="input-group-button"><button type="submit" class="button" (click)="copyLink()">Copy</button></div>
        </div>
        <div class="margin-bottom-1">
          <span>Anyone who has the link can access this file.</span>
        </div>
      </div>
    </div>
    <div *ngIf="sharelinkError" class="small callout alert">{{ sharelinkError }}</div>
  </div>

  <form
    (ngSubmit)="onClickShareButton(shareDocumentFormGroup.value)"
    [formGroup]="shareDocumentFormGroup"
    data-cy="share-form"
  >
    <div class="grid-x align-middle">
      <div class="cell auto">
        <rav-input
          [controlFormGroup]="shareDocumentFormGroup"
          controlName="send_pdf_via_email"
          placeholder="Enter Email Address"
        ></rav-input>
      </div>

      <div *ngIf="isSharingEmail" class="cell shrink margin-left-1">
        <img class="share__icon" src="/assets/images/loading.gif" alt="Loading spinner" data-cy="email-loader-icon" />
      </div>
      <div *ngIf="shareEmailSuccessful" class="cell shrink margin-left-1">
        <rav-icon [name]="RavIconCircled.Check" class="share__icon success-color" data-cy="email-succeed-icon">
        </rav-icon>
      </div>
    </div>

    <div class="margin-bottom-1">
      <div class="small bordered alert callout" *ngIf="emailErrorMsg" data-cy="error-message">
        <i class="fa fa-exclamation-triangle"></i>
        {{ emailErrorMsg }}
      </div>
      <div *ngIf="emailMessage" data-cy="message">
        {{ emailMessage }}
      </div>
    </div>
    <div>
      <div class="grid-x align-middle">
        <div class="cell auto">
          <rav-input
            [controlFormGroup]="shareDocumentFormGroup"
            controlName="send_pdf_via_fax"
            placeholder="Enter Fax Number"
          >
          </rav-input>
        </div>
        <div *ngIf="isSharingFax" class="cell shrink margin-left-1">
          <img class="share__icon" src="/assets/images/loading.gif" alt="Loading spinner" data-cy="fax-loader-icon" />
        </div>
        <div *ngIf="shareFaxSuccessful" class="cell shrink margin-left-1">
          <rav-icon [name]="RavIconCircled.Check" class="share__icon success-color" data-cy="fax-succeed-icon">
          </rav-icon>
        </div>
      </div>
    </div>

    <div class="margin-bottom-1">
      <div class="small bordered alert callout" *ngIf="faxErrorMsg" data-cy="error-message">
        <i class="fa fa-exclamation-triangle"></i>
        {{ faxErrorMsg }}
      </div>
      <div *ngIf="faxMessage" data-cy="message">
        {{ faxMessage }}
      </div>
    </div>

    <div class="flex-end">
      <button type="button" data-cy="cancel-button" class="hollow button margin-right-1" (click)="cancelShare()">
        Cancel
      </button>
      <button
        type="submit"
        data-cy="share_submit"
        [disabled]="!shareDocumentFormGroup.valid || isSharingEmail || isSharingFax"
        class="button"
      >
        {{ isSharingEmail || isSharingFax ? 'Sharing' : 'Share' }}
      </button>
    </div>
  </form>
</rav-modal>
